module.exports = __webpack_public_path__ + "img/logo-8.371fe8b7.svg";